<script setup lang="ts">
const year = new Date().getFullYear()
</script>

<template>
  <!-- Footer -->
  <footer class="border-t border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-950">
    <UContainer class="py-10">
      <div class="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
        <p class="text-sm text-slate-500 dark:text-slate-400">
          © {{ year }} PureJoule — Coaching & Performance
        </p>

        <div class="flex gap-5 text-sm">
          <a class="text-slate-600 hover:text-slate-900 dark:text-slate-300 dark:hover:text-white" href="/privacy">
            Privacy
          </a>
          <a class="text-slate-600 hover:text-slate-900 dark:text-slate-300 dark:hover:text-white" href="/terms">
            Termini
          </a>
          <a class="text-slate-600 hover:text-slate-900 dark:text-slate-300 dark:hover:text-white" href="#contacts">
            Contatti
          </a>
        </div>
      </div>
    </UContainer>
  </footer>
</template>

<style scoped>

</style>
